export const routeName = 'ReclamationPage'

export const route = {
  path: '/reclamation',
  name: routeName
}
